import cn from "classnames";

import { BoxShadowLayoutProps } from "./BoxShadowLayout.types";

import styles from "./BoxShadowLayout.module.scss";

const BoxShadowLayout = ({ children, className }: BoxShadowLayoutProps) => {
  return (
    <div className={cn(styles["box-shadow-layout"], className)}>{children}</div>
  );
};

export default BoxShadowLayout;
